

const ACTIVATION_KEY_STORAGE_KEY = 'uvexplorerActivationKey';
const REQUEST_TIMEOUT_MS = 15000;
const UTM_PARAM_NAMES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

let isSubmitting = false;

const storedKey = localStorage.getItem(ACTIVATION_KEY_STORAGE_KEY);

if (storedKey) {
    displayStoredActivationResult(storedKey);

    //Start auto-download
    /* ToDo: Clarify auto-download

    const form = document.getElementById('js-uvexplorer-form');
    startDownload(form.dataset.formDownloadUrl); */
} else {
    document.getElementById('js-uvexplorer-form').style.display = '';
}

window.showResult = showResult;

async function showResult(e) {
    e.preventDefault();
    if (isSubmitting) {
        return false;
    }
    isSubmitting = true;

    const form = document.getElementById('js-uvexplorer-form');
    hideError(form);
    showLoadingOverlay(form);

    try {
        // Load license activation result from server and display it in the result container
        const result = await requestActivation(form);
        if (result === null) {
            return false;
        }

        form.style.display = 'none';
        displayActivationResult(result);

        const hubspotToken = getHubspotUserToken();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'UVExplorerKeyComb', 'hubSpotId': hubspotToken,'trialKey': result});


        const resultContainer = document.getElementById('js-uvexplorer-activation-result-wrapper');
        resultContainer.style.display = 'block';

        try {
            localStorage.setItem(ACTIVATION_KEY_STORAGE_KEY, result);
        } catch (err) {
            console.error('Could not store activation key in local storage.', err);
        }

        startDownload(form.dataset.formDownloadUrl);
    } catch (err) {
        console.error(err);
        form.style.display = '';
        showError(form, form.dataset.defaultErrorMessage || 'There was an error with your request. Please try again or contact our customer support.');
    } finally {
        isSubmitting = false;
        hideLoadingOverlay(form);
    }
}

async function requestActivation(form) {
    const formDataEntries = [];
    for (const entry of new FormData(form)) {
        const key = entry[0];
        const value = entry[1];
        formDataEntries.push([key, String(value)]);
    }
    const params = new URLSearchParams(formDataEntries);

    const hubspotUserToken = await getHubspotUserToken();
    if (hubspotUserToken) {
        params.set('args[hubspotUserToken]', hubspotUserToken);
    }

    const currentUrlParams = new URLSearchParams(window.location.search);
    UTM_PARAM_NAMES.forEach((utmParamName) => {
        const utmParamValue = currentUrlParams.get(utmParamName);
        if (utmParamValue) {
            params.set(`args[${utmParamName}]`, utmParamValue);
        }
    });

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    const fetchResponse = await fetch(form.dataset.formTargetUrl, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
        },
        body: params,
        signal: controller.signal,
    }).catch(() => null);
    clearTimeout(timeoutId);

    if (!fetchResponse || fetchResponse.status > 300) {
        showError(form, form.dataset.defaultErrorMessage || 'There was an error with your request. Please try again or contact our customer support.');
        return null;
    }

    const responseText = await fetchResponse.text();
    let parsed;
    try {
        parsed = JSON.parse(responseText);
    } catch {
        showError(form, form.dataset.defaultErrorMessage || 'There was an error with your request. Please try again or contact our customer support.');
        return null;
    }

    if (parsed && parsed.error) {
        showError(form, parsed.error);
        return null;
    }
    if (parsed && Object.prototype.hasOwnProperty.call(parsed, 'activationResult')) {
        return parsed.activationResult;
    }
    return typeof parsed === 'string' ? parsed : JSON.stringify(parsed, undefined, 2);
}

function displayStoredActivationResult(activationResult) {
    const form = document.getElementById('js-uvexplorer-form');
    if (form) {
        form.style.display = 'none';
    }

    displayActivationResult(activationResult);

    const resultContainer = document.getElementById('js-uvexplorer-activation-result-wrapper');
    resultContainer.style.display = 'block';
}

function displayActivationResult(activationResult) {
    const resultElement = document.querySelector('.js-activation-result');
    resultElement.textContent = activationResult;

    resultElement.addEventListener('copy', (e) => {
        const selection = window.getSelection().toString();
        const textWithNewlines = selection.replace(/\r?\n/g, '\n');
        e.clipboardData.setData('text/plain', textWithNewlines);
        e.preventDefault();
    });
    document.querySelector('.js-copy-activation-result-button').addEventListener('click', () => {
        navigator.clipboard.writeText(activationResult);
        const range = document.createRange();
        range.selectNode(resultElement);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        resultElement.focus();
    });
}

function startDownload(downloadUrl) {
    if (!downloadUrl) {
        return;
    }
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function showError(form, message) {
    const errorContainer = form.querySelector('.js-license-activation-error');
    errorContainer.innerHTML = message;
    errorContainer.style.display = 'block';
    form.querySelectorAll('input').forEach((input) => {
        input.addEventListener('focus', hideErrorOnFocus);
    });
}

function showLoadingOverlay(form) {
    form.querySelector('.js-license-activation-loading-overlay').style.display = 'flex';
}

function hideLoadingOverlay(form) {
    form.querySelector('.js-license-activation-loading-overlay').style.display = 'none';
}

function hideErrorOnFocus(event) {
    hideError(event.target.closest('form'));
}

function hideError(form) {
    form.querySelector('.js-license-activation-error').style.display = 'none';
    form.querySelectorAll('input').forEach((input) => {
        input.removeEventListener('focus', hideErrorOnFocus);
    });
}

async function getHubspotUserToken() {
    if (typeof cookieStore === 'undefined') {
        return null;
    }
    try {
        const cookie = await cookieStore.get('hubspotutk');
        return cookie ? cookie.value : null;
    } catch {
        return null;
    }
}
